import React, {useEffect, useState} from "react";
import {SWIREPAY_URL} from "../../../appconstants";
import ErrorPage from "../../../components/error";

const WooCommercePaymentError = (props) => {
  const [errorBody, setErrorBody] = useState('We were unable to process and save your order, sorry. Some necessary required parameters were missed.' +
    'It looks like the payment gateway isn\'t set up correctly.\n\n\nIf you\'re the store owner please set up your payment gateway correctly or contact the store administrator otherwise.\n');
  useEffect(() => {
    const query = new URLSearchParams(props && props.location && props.location.search);
    const queryError = query && query.get('errorMsg');
    if(queryError) {setErrorBody(errorBody + '\nError details: ' + queryError + '\n');}
  }, []);
  return (
      <ErrorPage
        heading={'Error processing your order'}
        body={errorBody}
        url={SWIREPAY_URL}
      />
  )
};

export default WooCommercePaymentError;
